import { playButtonActionTypes } from '@/components/playButton/Constants';

import type {
	GetSongRequestAction,
	GetSongSuccessAction,
	IsAudioPlayingAction,
	PauseSongAction,
	RemoveSongAction,
	SetSongIdAction,
	Song,
} from '@/components/playButton/types';

export function getSong(
	id: string | number,
	word: string,
	lang: string,
	shouldHighlight = true,
): GetSongRequestAction {
	return {
		type: playButtonActionTypes.GET_SONG_REQUEST,
		payload: {
			id,
			word,
			lang,
			shouldHighlight,
		},
	};
}

export function getSongSuccess(id: string | number, song: Song): GetSongSuccessAction {
	return {
		type: playButtonActionTypes.GET_SONG_SUCCESS,
		payload: {
			id,
			song,
		},
	};
}

export function removeSong(): RemoveSongAction {
	return {
		type: playButtonActionTypes.REMOVE_SONG,
		payload: {},
	};
}

export function pauseSong(paused: boolean): PauseSongAction {
	return {
		type: playButtonActionTypes.PAUSE_SONG,
		payload: { paused },
	};
}

export function setIsAudioPlaying(
	isAudioPlaying: boolean,
	isProcessing = false,
): IsAudioPlayingAction {
	return {
		type: playButtonActionTypes.IS_AUDIO_PLAYING,
		payload: { isAudioPlaying, isProcessing },
	};
}

export function setSongId(id: string | number | null): SetSongIdAction {
	return {
		type: playButtonActionTypes.SET_SONG_ID,
		payload: { id },
	};
}
